var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.626,
    height: 35,
    viewBox: "0 0 30.626 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bell",
    transform: "translate(-2.25 -0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_115",
    "data-name": "Path 115",
    d: "M18,36a4.5,4.5,0,0,0,4.5-4.5h-9A4.5,4.5,0,0,0,18,36Z",
    transform: "translate(-0.437 -0.999)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_116",
    "data-name": "Path 116",
    d: "M17.563,4.169l-1.743.35a8.712,8.712,0,0,0-7.007,8.521,46.789,46.789,0,0,1-1,8.131,27.915,27.915,0,0,1-1.451,4.906H28.767a28.165,28.165,0,0,1-1.451-4.906,46.959,46.959,0,0,1-1-8.131A8.712,8.712,0,0,0,19.306,4.52l-1.743-.354ZM31.169,26.078a5.536,5.536,0,0,0,1.706,2.173H2.25a5.536,5.536,0,0,0,1.706-2.173c1.969-3.912,2.669-11.126,2.669-13.039a10.887,10.887,0,0,1,8.761-10.65A2.169,2.169,0,0,1,16.407.329a2.2,2.2,0,0,1,2.311,0,2.169,2.169,0,0,1,1.021,2.06A10.888,10.888,0,0,1,28.5,13.039c0,1.912.7,9.127,2.669,13.039Z",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.46e752cfbc47294e82fcce417203c00e.svg";
export { ForwardRef as ReactComponent };